import React from "react";
import { Paper, Box, Typography, Chip } from "@mui/material";
import { getColorEstado } from "../../pedidosEnvasado/VistaPedidosSimple/config/estadosPedido";

// Resumen por estado; un clic filtra la tabla y otro clic quita el filtro
export const EstadoChips = ({ porEstado, seleccionado, onSeleccionar }) => {
  const estados = Object.entries(porEstado).sort((a, b) => b[1].cantidad - a[1].cantidad);

  return (
    <Paper elevation={0} sx={{ p: 2, mb: 2, border: "1px solid #e0e0e0", borderRadius: 2 }}>
      <Typography variant="body2" sx={{ color: "#5f6368", fontWeight: 500, mb: 1.5 }}>
        Por estado
      </Typography>

      {estados.length === 0 ? (
        <Typography variant="body2" sx={{ color: "#9aa0a6" }}>
          Sin pedidos en el rango
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {estados.map(([valor, { cantidad, estado }]) => {
            const { accent } = getColorEstado(estado);
            const activo = seleccionado === valor;
            return (
              <Chip
                key={valor}
                onClick={() => onSeleccionar(activo ? null : valor)}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: activo ? "#fff" : accent }} />
                    {valor}
                    <Typography component="span" variant="body2" fontWeight={600}>
                      {cantidad}
                    </Typography>
                  </Box>
                }
                sx={{
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: activo ? accent : "#e0e0e0",
                  bgcolor: activo ? accent : "#fff",
                  color: activo ? "#fff" : "#202124",
                  "&:hover": { bgcolor: activo ? accent : "#f5f5f5" },
                }}
              />
            );
          })}
        </Box>
      )}
    </Paper>
  );
};
